import * as loaders from "@lts/loaders/legacy/legacy-glTFFileLoader";
export { loaders };
export default loaders;
